import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./lib/auth-context";
import { ContrastProvider } from "./lib/contrast-context";
import { AppRouter } from "./router";
import { Toaster } from "./components/ui/sonner";
import { ErrorBoundary } from "./components/error-boundary";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, gcTime: 5 * 60_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ContrastProvider>
          <ErrorBoundary scope="application" title="This page could not load" description="The dashboard hit an unexpected problem. You can try again without losing your session.">
            <AppRouter />
          </ErrorBoundary>
          <Toaster richColors position="top-right" />
        </ContrastProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
